'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var cache = {};

var translate = function translate(_ref, intl) {
  var id = _ref.id,
      values = _ref.values,
      rest = _objectWithoutProperties(_ref, ['id', 'values']);

  var cacheId = id + (typeof intl !== 'undefined' ? intl.locale : '') + (JSON.stringify(values) || '');
  if (cache[cacheId]) return cache[cacheId];

  var g = typeof window !== 'undefined' && window || typeof global !== 'undefined' && global || {};

  if (!intl) console.error('Missing intl object for "' + id + '"');

  if (g.showTranslations || !intl || !intl.formatMessage) return id;

  var message = intl.formatMessage(_extends({ id: id }, rest), values);
  cache[cacheId] = message;
  return message;
};

exports.default = translate;